import styled from "styled-components";
import { Row } from "../../pages/Assets/style";


export const Container = styled.div`
    display: flex;
    gap: 32px;
`
export const ItemContainer = styled(Row)`
    :hover{
        cursor: pointer;
    }
`
interface IRadioBtnProps {
    isActive: boolean
    
}

export const RadioBtn = styled.div<IRadioBtnProps>`
    display: flex;
    align-items: center;
    justify-content: center;
    border: 1px solid #CCC4B2;
    border-radius: 50%;
    height: 25px;
    width: 25px;
    &::after {
        content: '';
        background: #FFD550;
        border-radius: 50%;
        height: 15px;
        width: 15px;
        display: ${props => props.isActive ? 'block' : 'none'}
    }
`